const COMMENTS_FIELD_IDS = ['comment', 'Comment'];

const isCommentsHidden = (role) => COMMENTS_FIELD_IDS.some((fieldId) => role?.hiddenFields?.includes(fieldId));

export default isCommentsHidden;
